import React from 'react';
import styled from 'styled-components';
import { Div } from 'styles/elements/div';
import media from 'styles/media';
import { ReactComponent as TickIcon } from './tick.svg';

const Circle = styled(Div)`
  height: 24px;
  width: 24px;
  min-width: 24px;
  background: ${props => props.theme.completeColor};
  color: white;
  border-radius: 50%;
`;

const Tick = styled(TickIcon)`
  fill: white;
  height: 12px
  width: 12px;
  margin: auto;
  ${media.IE9 ? 'margin: 6px' : ''};
`;

export const OkCircle = ({ className }) => (
  <Circle className={className}>
    <Tick />
  </Circle>
);
